import { MoreOutlined } from '@ant-design/icons'
import { Dropdown, message } from 'antd'
import { useTranslation } from 'react-i18next'

import { Role } from '../types/roles-page-types'

interface RolesActionsDropdownProps {
  initialRoles: Role[]
  roleId: number
  name: string
  onDelete: (roleId: number) => void
  setIsRoleModalOpen: (isOpen: boolean) => void
  setname: (name: string) => void
}

export const RolesActionsDropdown = ({ roleId, name, onDelete, setIsRoleModalOpen, setname }: RolesActionsDropdownProps) => {
  const { t } = useTranslation()

  const handleDelete = () => {
    onDelete(roleId)
    message.success(t('rolesPage.rolesActionsDropdown.deleteSuccess'))
  }

  const showEditRoleModal = () => {
    setIsRoleModalOpen(true)
    setname(name)
  }

  const items = [
    {
      label: <span onClick={handleDelete}>{t('rolesPage.rolesActionsDropdown.deleteButton')}</span>,
      key: 'delete',
    },
    {
      label: <span onClick={showEditRoleModal}>{t('rolesPage.rolesActionsDropdown.editButton')}</span>,
      key: 'edit',
    },
  ]

  return (
    <Dropdown
      menu={{ items }}
      trigger={['hover']}
    >
      <MoreOutlined style={{ cursor: 'pointer' }} />
    </Dropdown>
  )
}
